import React from 'react';

function KlaviyoForm() {
  return <div className='klaviyo-form-X77Xqt' />;
}

export default KlaviyoForm;
